import { render, staticRenderFns } from "./DetailBar.vue?vue&type=template&id=b410fdbe&scoped=true&"
import script from "./DetailBar.vue?vue&type=script&lang=js&"
export * from "./DetailBar.vue?vue&type=script&lang=js&"
import style0 from "./DetailBar.vue?vue&type=style&index=0&id=b410fdbe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b410fdbe",
  null
  
)

export default component.exports